export const dashboard = {
  // dashboard home
  welcome_to_dashboard: 'Bienvenue !',
  goodMorning: 'Bonjour',
};
